<template>
  <div v-if="$store.state.fastPermissoes.administrador == 'S' && $store.state.fastPermissoes.ativo == 'S'">
    <div class="fd-app-wrap">
      <div class="container">
        <!-- breadcrumb -->
        <nav>
          <ul class="fd-app-breadcrumb">
            <li class="fd-app-breadcrumb-item">
              <a
                href="/minhas-plataformas"
                class="aluno_font_color"
                @click.prevent="$router.push('/minhas-plataformas')"
              >Minhas Plataformas</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a
                class="aluno_font_color"
                :href="'/plataforma/' + $route.params.id_plataforma"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma)"
              >Plataforma {{ $store.state.fastPlataforma.nome_plataforma }}</a>
            </li>
            <li class="fd-app-breadcrumb-item">
              <a
                class="aluno_font_color"
                :href="'/plataforma/' + $route.params.id_plataforma + '/admin'"
                @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/admin')"
              >Modo admin</a>
            </li>
            <li class="fd-app-breadcrumb-item active">
              <a
                class="aluno_font_color"
                href="#"
              >Dashboard</a>
            </li>
          </ul>
        </nav>
        <!-- /breadcrumb -->
      </div>

      <div class="fd-mode-adm-content mt-4">
        <div class="container">
          <div class="row">
            <div
              id="body_conteudo_modo_admin"
              class="col-sm-12 col-md-12 fd-mode-adm-content-body col-lg-12 ml-0"
            >
              <!-- fd-app-welcome -->
              <section class="fd-app-welcome text-left">
                <h1 class="aluno_font_color">
                  Dashboard da
                  <span id="txtDashboardNomePlataforma">Plataforma</span>
                </h1>
                <img :src="require('@/assets/images/form-effect-01.png')">
              </section>
              <!-- /fd-app-welcome -->
              <!-- fd-app-content -->
              <section
                v-if="$store.state.fastPermissoes.id_admin_pai == 0"
                class="fd-app-content"
              >
                <div class="text-center mt-3">
                  <a
                    class="btn btn-danger btn-xs d-none"
                    href="#"
                    data-toggle="modal"
                    data-target="#modal-desativar-plataforma"
                    style
                  >Desativar plataforma</a>
                  <!-- #modal-desativar-plataforma-->
                  <div
                    id="modal-desativar-plataforma"
                    class="modal fade"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-lg"
                      role="document"
                    >
                      <div class="modal-content mt-5">
                        <div class="modal-header">
                          <h3>Desativação da plataforma</h3>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div
                            id="divPlataformasFilhasDesativacao"
                            class="col-12"
                          >
                            <h5>Plataformas filhas</h5>
                            <p class="text-success">
                              Nenhuma plataforma filha encontrada
                              <i class="far fa-thumbs-up" />
                            </p>
                            <div class="col-12">
                              <span
                                class="btn btn-danger"
                                onclick="desativarPlataforma(273)"
                              >Confirmar desativação</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- #modal-desativar-plataforma-->

                  <a
                    class="btn btn-success btn-xs d-none"
                    href="#"
                    data-toggle="modal"
                    data-target="#modal-reativar-plataforma"
                    style="display: none"
                  >Reativar plataforma</a>
                  <!-- #modal-reativar-plataforma-->
                  <div
                    id="modal-reativar-plataforma"
                    class="modal fade"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-lg"
                      role="document"
                    >
                      <div class="modal-content mt-5">
                        <div class="modal-header">
                          <h3>Desativação da plataforma</h3>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div
                            id="divPlataformasFilhasReativacao"
                            class="col-12"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- #modal-reativar-plataforma-->

                  <a
                    class="btn btn-danger btn-xs"
                    href="#"
                    style
                    @click.prevent="showModal('modalExcluirPlataforma')"
                  >Excluir plataforma</a>
                  <!-- #modal-desativar-plataforma-->
                  <modal
                    name="modalExcluirPlataforma"
                    height="auto"
                    :shift-y="0.1"
                    :focus-trap="true"
                    :adaptive="true"
                  >
                    <div class="row">
                      <div
                        v-if="plataformas_filhas.length"
                        class="col-12 p-4"
                      >
                        <h5>Plataformas filhas</h5>
                        <p
                          class="text-danger mb-0"
                        >
                          Foram encontradas {{ plataformas_filhas.length }} plataformas filhas!
                        </p>
                        <p
                          class="text-danger"
                        >
                          A exclusão dessa plataforma só poderá ser realizada caso não existam plataformas filhas.
                        </p>
                        <table class="table table-striped">
                          <tbody>
                            <tr
                              v-for="plataforma in plataformas_filhas"
                              :key="plataforma.id_plataforma"
                            >
                              <td class="align-middle">
                                <img
                                  v-lazy="plataforma.logo_plataforma"
                                  style="height: 100px"
                                  class="img-fluid"
                                >
                              </td>
                              <td class="align-middle">
                                {{ plataforma.nome_plataforma }}
                              </td>
                              <td class="align-middle">
                                <a
                                  class="btn btn-warning text-white"
                                  :href="'/plataforma/' + plataforma.id_plataforma + '/admin/dashboard'"
                                >Acessar</a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        v-else
                        class="col-12 p-4"
                      >
                        <div class="col-12 mb-4">
                          <span
                            class="text-danger"
                          >Ao excluir essa plataforma todos os cursos e usuários serão excluídos.</span>
                        </div>
                        <div class="col-12">
                          <span
                            class="btn btn-danger"
                            @click="excluirPlataforma()"
                          >Confirmar exclusão</span>
                        </div>
                      </div>
                    </div>
                  </modal>
                  <!-- #modal-desativar-plataforma-->
                </div>
              </section>
              <!-- /fd-app-content -->
              <!-- fd-app-capacitacoes -->
              <section class="fd-dashboard mt-4">
                <div class="fd-dashboard-card-list">
                  <div
                    class="fd-dashboard-card-list-item"
                    style="height: 260px"
                  >
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28.056"
                        height="38.928"
                        viewBox="0 0 28.056 38.928"
                      >
                        <g
                          id="teacher"
                          transform="translate(9.499 468)"
                        >
                          <g
                            id="Grupo_2"
                            data-name="Grupo 2"
                            transform="translate(-81 -468)"
                          >
                            <path
                              id="Caminho_1"
                              data-name="Caminho 1"
                              d="M99.519,36.235c-1.734-8.709-1.659-8.338-1.668-8.374a3.745,3.745,0,0,0-1.9-2.587,4.209,4.209,0,0,0-1.009-.39L90.678,23.4l-1.42-.974v-1.1a7.514,7.514,0,0,0,3.64-5.657,2.165,2.165,0,0,0,2.217-3.03V7.99c0-3.362-1.828-4.531-2.387-4.81A9.794,9.794,0,0,0,81.023,1.065l-.007,0A9.59,9.59,0,0,0,79.17,2.3a.57.57,0,0,0,.746.863A8.688,8.688,0,0,1,91.929,4a.548.548,0,0,0,.237.173c.074.03,1.809.76,1.809,3.814v3.6a2.454,2.454,0,0,0-1.033-.192V9.531a.912.912,0,0,0-.829-.91A2.252,2.252,0,0,1,90.336,7.4a1.144,1.144,0,0,0-1.746-.316,9.225,9.225,0,0,1-7.478,1.994A2.806,2.806,0,0,0,77.938,11.4a2.466,2.466,0,0,0-1.069.191c0-1.963-.224-4.1,1.381-6.547a.57.57,0,0,0-.955-.624c-2.185,3.348-1.4,6.348-1.567,8.22a2.165,2.165,0,0,0,2.217,3.03A7.5,7.5,0,0,0,79.936,20h0A7.746,7.746,0,0,0,81.8,21.449v.981l-1.42.974c-5.557,1.93-4.993,1.7-5.445,1.972A3.739,3.739,0,0,0,73.245,27.7c-.049.2.032-.174-1.705,8.54a3.13,3.13,0,0,0-.022.81,2.075,2.075,0,0,0,2.328,1.883H89.515a.57.57,0,1,0,0-1.14H77.856V32.563a.57.57,0,0,0-1.14,0v5.225h-2.87c-.894,0-1.314-.384-1.184-1.346,1.56-7.625,1.564-8.24,1.819-8.865a2.6,2.6,0,0,1,1.5-1.454,4.552,4.552,0,0,1,.476-.148c.026-.008-.1.037,1.944-.674l1.366,2.522a.57.57,0,0,0,1-.543l-1.277-2.358.873-.3,4.554,8.406a.7.7,0,0,0,1.18.082c.053-.073-.25.472,4.6-8.49l.873.3-4.616,8.539a1.613,1.613,0,0,1-2.836,0l-2.08-3.84a.57.57,0,0,0-1,.543L83.109,34a2.754,2.754,0,0,0,4.842,0l4.7-8.7c2.043.709,1.924.669,1.95.677.4.122.357.1.476.147a3.079,3.079,0,0,1,.689.394,2.54,2.54,0,0,1,.92,1.391c.027.1,1.72,8.491,1.727,8.774.017.716-.292,1.106-1.2,1.106h-2.87V32.563a.57.57,0,1,0-1.14,0v5.225H92.175a.57.57,0,0,0,0,1.14h5.037a2.074,2.074,0,0,0,2.328-1.882A3.167,3.167,0,0,0,99.519,36.235Zm-6.577-23.7a1.112,1.112,0,0,1,1.246,1,1.112,1.112,0,0,1-1.246,1ZM77.9,14.529a1.112,1.112,0,0,1-1.246-1,1.112,1.112,0,0,1,1.246-1ZM80.948,10.2A10.334,10.334,0,0,0,89.33,7.948l.008,0A3.384,3.384,0,0,0,91.8,9.731V11.75l-.651.384a1.481,1.481,0,0,0-1.218-.64H87.323a1.485,1.485,0,0,0-1.368.912H84.888a1.485,1.485,0,0,0-1.368-.912H80.911a1.481,1.481,0,0,0-1.218.64l-.648-.382A1.664,1.664,0,0,1,80.948,10.2Zm9.326,2.773v1.136a.9.9,0,0,1-.9.9h-1.5a.9.9,0,0,1-.9-.9V12.977h0a.347.347,0,0,1,.342-.342h2.609A.347.347,0,0,1,90.275,12.977Zm-6.412,0v1.136a.9.9,0,0,1-.9.9h-1.5a.9.9,0,0,1-.9-.9V12.977a.347.347,0,0,1,.342-.342H83.52A.347.347,0,0,1,83.862,12.977ZM80.58,19.011c-1.846-2.151-1.49-4.24-1.538-5.937l.386.228v.81a2.04,2.04,0,0,0,2.037,2.037h1.5A2.04,2.04,0,0,0,85,14.113v-.565h.838v.565a2.04,2.04,0,0,0,2.037,2.037h1.5a2.04,2.04,0,0,0,2.037-2.037V13.3l.386-.228v1.783a6.378,6.378,0,0,1-6.38,6.379h-.077a6.122,6.122,0,0,1-1.667-.241A6.394,6.394,0,0,1,80.58,19.011Zm4.949,6.379-2.588-2.88v-.553a7.529,7.529,0,0,0,4.442.161,7.444,7.444,0,0,0,.735-.24v.632Zm.642,2.032-.252.519h-.78l-.252-.519.642-.472Zm-2.145,1.569-.363-.67.289-.212.216.445Zm-.908-1.685-1.733-3.2.9-.618,2.4,2.673Zm2.41,4.459-.753-1.39.42-1.293h.666l.42,1.291Zm1.5-2.778-.141-.434.216-.445.286.21Zm.909-1.681-1.565-1.15,2.4-2.673.9.618Z"
                              transform="translate(0 0)"
                              fill="#d98840"
                            />
                          </g>
                        </g>
                      </svg>
                      <strong>
                        <span>Professores</span>
                        Disponíveis
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <ul
                        id="dashProfessoresDisponiveis"
                        class="fd-dashboard-card-list-item-body-list"
                        style="height: 150px; overflow: auto;"
                      >
                        <li>
                          <span>{{ total_professores }}</span>
                          <span>{{ nome_plataforma }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/usuarios?professores'"
                        target="_blank"
                      >Gerenciar professores</a>
                    </div>
                  </div>
                  <div
                    class="fd-dashboard-card-list-item"
                    style="height: 260px"
                  >
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        id="online-class"
                        xmlns="http://www.w3.org/2000/svg"
                        width="35.3"
                        height="36.517"
                        viewBox="0 0 35.3 36.517"
                      >
                        <path
                          id="Caminho_11"
                          data-name="Caminho 11"
                          d="M32.866,93.823a.609.609,0,0,1-.609.609H26.171V92.35a4.279,4.279,0,0,0-3.139-4.111l-3.556-.967V86.35A4.261,4.261,0,0,0,21.3,82.867V81.715c.155-.071.253-.122.272-.129a.609.609,0,0,0,.337-.545V77.39l3.262-1.254a.609.609,0,0,0,0-1.137L17.26,71.955a.615.615,0,0,0-.437,0L8.911,75a.609.609,0,0,0-.39.566v2.791L6.873,80l.861.861.787-.787v.965H9.738v-.965l.787.787L11.386,80,9.738,78.355v-1.9l2.434.94v3.652a.608.608,0,0,0,.337.548c.019.009.117.058.272.129v1.149a4.177,4.177,0,0,0,1.826,3.484v.919l-3.558.968A4.278,4.278,0,0,0,7.912,92.35v2.081H1.826a.609.609,0,0,1-.609-.609V70.086H18.259V68.869H1.217V65.826a.609.609,0,0,1,.609-.609H18.259V64H1.826A1.826,1.826,0,0,0,0,65.826v28a1.826,1.826,0,0,0,1.826,1.826H32.257a1.826,1.826,0,0,0,1.826-1.826V71.3H32.866ZM15.824,87.736v-.791a4.14,4.14,0,0,0,2.434,0v.791a.6.6,0,0,0,.212.452l-1.43,1.191-1.43-1.19a.6.6,0,0,0,.212-.453Zm1.217-14.564,6.216,2.391-6.216,2.391-6.216-2.391Zm-.218,6a.615.615,0,0,0,.437,0l3.433-1.321v2.8a10.443,10.443,0,0,1-3.652,1,10.47,10.47,0,0,1-3.652-1v-2.8ZM14,82.867v-.653a9.491,9.491,0,0,0,3.043.653,9.491,9.491,0,0,0,3.043-.653v.653A3.043,3.043,0,0,1,15.515,85.5a2.874,2.874,0,0,1-.626-.48A3,3,0,0,1,14,82.867ZM9.129,92.35a3.058,3.058,0,0,1,2.242-2.937l2.871-.781,2.41,2.008a.608.608,0,0,0,.779,0l2.41-2.008,2.869.78a3.059,3.059,0,0,1,2.243,2.937v2.081H23.128V92H21.91v2.434H12.172V92H10.955v2.434H9.129Zm0,0"
                          transform="translate(0 -59.131)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_12"
                          data-name="Caminho 12"
                          d="M48,96h1.217v1.217H48Zm0,0"
                          transform="translate(-44.348 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_13"
                          data-name="Caminho 13"
                          d="M80,96h1.217v1.217H80Zm0,0"
                          transform="translate(-73.914 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_14"
                          data-name="Caminho 14"
                          d="M112,96h1.217v1.217H112Zm0,0"
                          transform="translate(-103.479 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_15"
                          data-name="Caminho 15"
                          d="M270,0H257.826A1.826,1.826,0,0,0,256,1.826v7.3a1.826,1.826,0,0,0,1.826,1.826h1.826V13.39a.609.609,0,0,0,.407.574.628.628,0,0,0,.2.034.608.608,0,0,0,.475-.228l2.251-2.815H270a1.826,1.826,0,0,0,1.826-1.826v-7.3A1.826,1.826,0,0,0,270,0Zm.609,9.129a.609.609,0,0,1-.609.609h-7.3a.608.608,0,0,0-.475.228l-1.351,1.688V10.347a.609.609,0,0,0-.609-.609h-2.434a.609.609,0,0,1-.609-.609v-7.3a.609.609,0,0,1,.609-.609H270a.609.609,0,0,1,.609.609Zm0,0"
                          transform="translate(-236.524)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_16"
                          data-name="Caminho 16"
                          d="M304,32h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -29.566)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_17"
                          data-name="Caminho 17"
                          d="M304,64h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -59.131)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_18"
                          data-name="Caminho 18"
                          d="M304,96h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -88.697)"
                          fill="#d98840"
                        />
                      </svg>

                      <strong>
                        <span>Cursos</span>
                        Disponíveis
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <ul
                        id="dashCursosDisponiveis"
                        class="fd-dashboard-card-list-item-body-list"
                        style="height: 150px; overflow: auto;"
                      >
                        <li>
                          <span>{{ total_cursos_publicados_mae }}</span>
                          <span>{{ nome_plataforma }}</span>
                        </li>
                        <li
                          v-for="plataforma in plataformas_filhas_string"
                          :key="plataforma.split(',')[0]"
                        >
                          <span />
                          <span>{{ plataforma.split(",")[1] }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/meus-cursos'"
                        target="_blank"
                      >Gerenciar Cursos</a>
                    </div>
                  </div>
                  <div class="fd-dashboard-card-list-item">
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="45.345"
                        height="33.288"
                        viewBox="0 0 45.345 33.288"
                      >
                        <g
                          id="team"
                          transform="translate(0 -68.066)"
                        >
                          <g
                            id="Grupo_10"
                            data-name="Grupo 10"
                            transform="translate(34.784 82.27)"
                          >
                            <g
                              id="Grupo_9"
                              data-name="Grupo 9"
                            >
                              <path
                                id="Caminho_19"
                                data-name="Caminho 19"
                                d="M397.974,229.229a12.96,12.96,0,0,0-4.558-.78.664.664,0,1,0,0,1.328,11.47,11.47,0,0,1,3.964.64.664.664,0,0,0,.594-1.188Z"
                                transform="translate(-392.751 -228.449)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_12"
                            data-name="Grupo 12"
                            transform="translate(0 68.066)"
                          >
                            <g
                              id="Grupo_11"
                              data-name="Grupo 11"
                              transform="translate(0 0)"
                            >
                              <path
                                id="Caminho_20"
                                data-name="Caminho 20"
                                d="M43.318,92.507l-2.743-.784a.278.278,0,0,1-.2-.267v-.916a4.993,4.993,0,0,0,.635-.521,4.886,4.886,0,0,0,1.5-3.535V85.222l.265-.53a4.237,4.237,0,0,0,.445-1.885V79.383a.664.664,0,0,0-.664-.664H36.158a4.22,4.22,0,0,0-4.215,4.215v.04a3.523,3.523,0,0,0,.37,1.568l.34.68v1.085a5.183,5.183,0,0,0,2.131,4.19v.96c0,.148,0,.209-.548.366l-1.339.382L29.025,90.8a.663.663,0,0,0-.181-.509l-1.237-1.3V86.807c.131-.108.26-.218.385-.336A7.8,7.8,0,0,0,30.447,80.8V79.061a7.678,7.678,0,0,0,.71-3.229v-7.1a.664.664,0,0,0-.664-.664H20.55A6.353,6.353,0,0,0,14.2,74.412v1.42a7.678,7.678,0,0,0,.71,3.229v1.5a8.116,8.116,0,0,0,2.841,6.195v2.234l-1.237,1.3a.663.663,0,0,0-.181.509L12.25,92.283a3.483,3.483,0,0,0-.821.43l-.642-.321a5.073,5.073,0,0,0,2.545-2.059.664.664,0,0,0,0-.594,11.8,11.8,0,0,1-.583-4.124c-.015-.47-.03-.913-.058-1.308a5.778,5.778,0,0,0-5.634-5.589,5.778,5.778,0,0,0-5.634,5.589c-.028.4-.043.839-.058,1.308A11.8,11.8,0,0,1,.78,89.739a.664.664,0,0,0,0,.594,5.072,5.072,0,0,0,2.547,2.058l-1.783.891A2.78,2.78,0,0,0,0,95.782v4.907a.664.664,0,0,0,1.328,0V95.782a1.459,1.459,0,0,1,.811-1.312l2.22-1.11.772.734a2.793,2.793,0,0,0,3.851,0l.772-.734.724.362a3.5,3.5,0,0,0-.534,1.855v5.112a.664.664,0,0,0,1.328,0V95.578A2.183,2.183,0,0,1,12.7,93.532l4.309-1.567,1.794,2.691a1.369,1.369,0,0,0,1.008.605q.069.007.137.007a1.369,1.369,0,0,0,.97-.4l1.094-1.094v6.919a.664.664,0,0,0,1.328,0V93.771l1.094,1.094a1.369,1.369,0,0,0,.97.4q.068,0,.137-.007a1.369,1.369,0,0,0,1.008-.605l1.794-2.691,4.309,1.567a2.183,2.183,0,0,1,1.433,2.046v5.112a.664.664,0,0,0,1.328,0V95.578a3.511,3.511,0,0,0-.982-2.43L34.6,93.1a3.642,3.642,0,0,0,.618-.223l1.7,1.7v6.117a.664.664,0,0,0,1.328,0V94.573l1.684-1.684a1.58,1.58,0,0,0,.283.112l2.743.784a1.473,1.473,0,0,1,1.064,1.41v5.495a.664.664,0,0,0,1.328,0V95.2A2.807,2.807,0,0,0,43.318,92.507ZM4.261,91.334A4.775,4.775,0,0,1,2.13,89.966a7.322,7.322,0,0,0,.379-1.591,4.953,4.953,0,0,0,1.753,2.163Zm3.805,1.8a1.466,1.466,0,0,1-2.02,0l-.618-.587A1.374,1.374,0,0,0,5.59,91.9v-.708a4.939,4.939,0,0,0,2.933,0V91.9a1.374,1.374,0,0,0,.162.649Zm-1.01-3.049a3.6,3.6,0,0,1-3.6-3.6.66.66,0,0,0-.773-.654c0-.057,0-.114.006-.171.015-.457.029-.888.055-1.258a4.931,4.931,0,0,1,1.343-3.1,4.127,4.127,0,0,1,5.932,0,4.931,4.931,0,0,1,1.343,3.1c.026.37.041.8.056,1.258l0,.118a5.968,5.968,0,0,0-3.281-2.4,8.336,8.336,0,0,0-2.526-.4.664.664,0,0,0-.46.2l-1.2,1.243a.664.664,0,0,0,.956.922l1-1.034c.859.042,3.622.363,4.7,2.729A3.588,3.588,0,0,1,7.056,90.083Zm2.794,1.254v-.792A4.913,4.913,0,0,0,11.6,88.379a7.312,7.312,0,0,0,.378,1.587A4.8,4.8,0,0,1,9.851,91.336Zm6.392-10.776V78.913a.664.664,0,0,0-.066-.289,6.371,6.371,0,0,1-.644-2.791v-1.42a5.023,5.023,0,0,1,5.017-5.017h9.279v6.438a6.371,6.371,0,0,1-.644,2.791.664.664,0,0,0-.066.289V80.8a6.377,6.377,0,0,1-2.036,4.7,6.609,6.609,0,0,1-.51.432l-.011.008a6.387,6.387,0,0,1-4.31,1.286A6.579,6.579,0,0,1,16.243,80.561Zm3.74,13.365a.042.042,0,0,1-.037.013.042.042,0,0,1-.034-.02l-2.066-3.1.665-.7,3.134,2.142Zm2.7-2.563-3.6-2.459v-1.24a7.479,7.479,0,0,0,3.081.89q.263.017.523.017a7.694,7.694,0,0,0,3.59-.88V88.9Zm2.769,2.556a.042.042,0,0,1-.034.02.041.041,0,0,1-.037-.013l-1.662-1.662,3.134-2.142.665.7Zm12.129-.56-1.507-1.507a1.822,1.822,0,0,0,.041-.395v-.28a4.657,4.657,0,0,0,1.315.232l.153,0a4.934,4.934,0,0,0,1.464-.222v.267a1.588,1.588,0,0,0,.048.387Zm2.5-4.291a3.57,3.57,0,0,1-2.616,1.014,3.718,3.718,0,0,1-3.486-3.774V85.065a.664.664,0,0,0-.07-.3l-.41-.821a2.188,2.188,0,0,1-.23-.973v-.04a2.89,2.89,0,0,1,2.887-2.887h5.728v2.759a2.9,2.9,0,0,1-.3,1.291l-.335.671a.664.664,0,0,0-.07.3v1.42A3.569,3.569,0,0,1,40.083,89.067Z"
                                transform="translate(0 -68.066)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_14"
                            data-name="Grupo 14"
                            transform="translate(41.176 95.764)"
                          >
                            <g
                              id="Grupo_13"
                              data-name="Grupo 13"
                              transform="translate(0 0)"
                            >
                              <path
                                id="Caminho_21"
                                data-name="Caminho 21"
                                d="M465.587,380.814a.664.664,0,0,0-.664.664v4.261a.664.664,0,0,0,1.328,0v-4.261A.664.664,0,0,0,465.587,380.814Z"
                                transform="translate(-464.923 -380.814)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_16"
                            data-name="Grupo 16"
                            transform="translate(2.841 96.642)"
                          >
                            <g
                              id="Grupo_15"
                              data-name="Grupo 15"
                            >
                              <path
                                id="Caminho_22"
                                data-name="Caminho 22"
                                d="M32.741,390.728a.664.664,0,0,0-.664.664v3.383a.664.664,0,1,0,1.328,0v-3.383A.664.664,0,0,0,32.741,390.728Z"
                                transform="translate(-32.077 -390.728)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_18"
                            data-name="Grupo 18"
                            transform="translate(17.045 74.1)"
                          >
                            <g
                              id="Grupo_17"
                              data-name="Grupo 17"
                            >
                              <path
                                id="Caminho_23"
                                data-name="Caminho 23"
                                d="M203.537,138.175c-2.512-2.512-7.768-2.032-9.912-1.709a1.364,1.364,0,0,0-1.165,1.358v1.53a.664.664,0,0,0,1.328,0v-1.53a.044.044,0,0,1,.035-.045,20.984,20.984,0,0,1,4.315-.211,6.856,6.856,0,0,1,4.459,1.545.664.664,0,0,0,.939-.939Z"
                                transform="translate(-192.46 -136.203)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_20"
                            data-name="Grupo 20"
                            transform="translate(14.204 97.185)"
                          >
                            <g
                              id="Grupo_19"
                              data-name="Grupo 19"
                            >
                              <path
                                id="Caminho_24"
                                data-name="Caminho 24"
                                d="M161.048,396.853a.664.664,0,0,0-.664.664v2.841a.664.664,0,1,0,1.328,0v-2.841A.664.664,0,0,0,161.048,396.853Z"
                                transform="translate(-160.384 -396.853)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                          <g
                            id="Grupo_22"
                            data-name="Grupo 22"
                            transform="translate(29.829 97.185)"
                          >
                            <g
                              id="Grupo_21"
                              data-name="Grupo 21"
                            >
                              <path
                                id="Caminho_25"
                                data-name="Caminho 25"
                                d="M337.47,396.853a.664.664,0,0,0-.664.664v2.841a.664.664,0,1,0,1.328,0v-2.841A.664.664,0,0,0,337.47,396.853Z"
                                transform="translate(-336.806 -396.853)"
                                fill="#d98840"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>

                      <strong>
                        <span>Pessoas</span>
                        Treinadas
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <div
                        id="dashPessoasTreinadas"
                        class="fd-dashboard-card-list-item-body-info"
                      >
                        <span>{{ total_usuarios_treinados }}</span>
                        <strong>{{ nome_plataforma }}</strong>
                      </div>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/meus-cursos'"
                        target="_blank"
                      >Gerenciar Cursos</a>
                    </div>
                  </div>
                </div>
                <div class="fd-dashboard-card-list">
                  <div class="fd-dashboard-card-list-item">
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="38.5"
                        height="29.517"
                        viewBox="0 0 38.5 29.517"
                      >
                        <g
                          id="homework"
                          transform="translate(-2 -9)"
                        >
                          <path
                            id="Caminho_26"
                            data-name="Caminho 26"
                            d="M39.858,11.567H37.933V9.642A.642.642,0,0,0,37.292,9H23.817a3.2,3.2,0,0,0-2.567,1.3A3.2,3.2,0,0,0,18.683,9H5.208a.642.642,0,0,0-.642.642v1.925H2.642A.642.642,0,0,0,2,12.208V37.875a.642.642,0,0,0,.642.642H39.858a.642.642,0,0,0,.642-.642V12.208A.642.642,0,0,0,39.858,11.567ZM3.283,37.233V12.85H4.567V35.308a.642.642,0,0,0,.642.642H18.683a1.931,1.931,0,0,1,1.809,1.283Zm17.325-1.906a3.16,3.16,0,0,0-1.925-.661H5.85V10.283H18.683a1.931,1.931,0,0,1,1.925,1.925Zm.642.642-.019-.019h.038Zm.642-23.761a1.931,1.931,0,0,1,1.925-1.925H36.65V34.667H23.817a3.16,3.16,0,0,0-1.925.661ZM39.217,37.233H22.007a1.931,1.931,0,0,1,1.809-1.283H37.292a.642.642,0,0,0,.642-.642V12.85h1.283Z"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_27"
                            data-name="Caminho 27"
                            d="M45.567,13A2.567,2.567,0,0,0,43,15.567v15.4a.642.642,0,0,0,.09.327L45.015,34.5a.642.642,0,0,0,1.1,0l1.925-3.208a.642.642,0,0,0,.09-.327v-15.4A2.567,2.567,0,0,0,45.567,13Zm0,19.93-1.059-1.771,1.059-.706,1.059.706Zm1.283-3.163-.642-.43V20.7H44.925v8.637l-.642.43V19.417H46.85Zm0-11.633H44.283V16.85H46.85Zm-2.567-2.567a1.283,1.283,0,1,1,2.567,0Z"
                            transform="translate(-14.692 -1.433)"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_28"
                            data-name="Caminho 28"
                            d="M10,14H22.192v1.283H10Z"
                            transform="translate(-2.867 -1.792)"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_29"
                            data-name="Caminho 29"
                            d="M10,18h7.058v1.283H10Z"
                            transform="translate(-2.867 -3.225)"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_30"
                            data-name="Caminho 30"
                            d="M23,18h3.85v1.283H23Z"
                            transform="translate(-7.525 -3.225)"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_31"
                            data-name="Caminho 31"
                            d="M10,22h2.567v1.283H10Z"
                            transform="translate(-2.867 -4.658)"
                            fill="#d98840"
                          />
                          <path
                            id="Caminho_32"
                            data-name="Caminho 32"
                            d="M16,22h8.342v1.283H16Z"
                            transform="translate(-5.017 -4.658)"
                            fill="#d98840"
                          />
                        </g>
                      </svg>
                      <strong>
                        <span>Cursos</span>
                        em execução
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <div class="fd-dashboard-card-list-item-body">
                        <div
                          id="dashCursosEmExecucao"
                          class="fd-dashboard-card-list-item-body-info"
                        >
                          <span>{{ total_cursos_em_execucao }}</span>
                          <strong>{{ nome_plataforma }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/usuarios?Alunos'"
                        target="_blank"
                      >Gerenciar performance</a>
                    </div>
                  </div>

                  <div class="fd-dashboard-card-list-item">
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        id="online-class"
                        xmlns="http://www.w3.org/2000/svg"
                        width="35.3"
                        height="36.517"
                        viewBox="0 0 35.3 36.517"
                      >
                        <path
                          id="Caminho_11"
                          data-name="Caminho 11"
                          d="M32.866,93.823a.609.609,0,0,1-.609.609H26.171V92.35a4.279,4.279,0,0,0-3.139-4.111l-3.556-.967V86.35A4.261,4.261,0,0,0,21.3,82.867V81.715c.155-.071.253-.122.272-.129a.609.609,0,0,0,.337-.545V77.39l3.262-1.254a.609.609,0,0,0,0-1.137L17.26,71.955a.615.615,0,0,0-.437,0L8.911,75a.609.609,0,0,0-.39.566v2.791L6.873,80l.861.861.787-.787v.965H9.738v-.965l.787.787L11.386,80,9.738,78.355v-1.9l2.434.94v3.652a.608.608,0,0,0,.337.548c.019.009.117.058.272.129v1.149a4.177,4.177,0,0,0,1.826,3.484v.919l-3.558.968A4.278,4.278,0,0,0,7.912,92.35v2.081H1.826a.609.609,0,0,1-.609-.609V70.086H18.259V68.869H1.217V65.826a.609.609,0,0,1,.609-.609H18.259V64H1.826A1.826,1.826,0,0,0,0,65.826v28a1.826,1.826,0,0,0,1.826,1.826H32.257a1.826,1.826,0,0,0,1.826-1.826V71.3H32.866ZM15.824,87.736v-.791a4.14,4.14,0,0,0,2.434,0v.791a.6.6,0,0,0,.212.452l-1.43,1.191-1.43-1.19a.6.6,0,0,0,.212-.453Zm1.217-14.564,6.216,2.391-6.216,2.391-6.216-2.391Zm-.218,6a.615.615,0,0,0,.437,0l3.433-1.321v2.8a10.443,10.443,0,0,1-3.652,1,10.47,10.47,0,0,1-3.652-1v-2.8ZM14,82.867v-.653a9.491,9.491,0,0,0,3.043.653,9.491,9.491,0,0,0,3.043-.653v.653A3.043,3.043,0,0,1,15.515,85.5a2.874,2.874,0,0,1-.626-.48A3,3,0,0,1,14,82.867ZM9.129,92.35a3.058,3.058,0,0,1,2.242-2.937l2.871-.781,2.41,2.008a.608.608,0,0,0,.779,0l2.41-2.008,2.869.78a3.059,3.059,0,0,1,2.243,2.937v2.081H23.128V92H21.91v2.434H12.172V92H10.955v2.434H9.129Zm0,0"
                          transform="translate(0 -59.131)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_12"
                          data-name="Caminho 12"
                          d="M48,96h1.217v1.217H48Zm0,0"
                          transform="translate(-44.348 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_13"
                          data-name="Caminho 13"
                          d="M80,96h1.217v1.217H80Zm0,0"
                          transform="translate(-73.914 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_14"
                          data-name="Caminho 14"
                          d="M112,96h1.217v1.217H112Zm0,0"
                          transform="translate(-103.479 -88.697)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_15"
                          data-name="Caminho 15"
                          d="M270,0H257.826A1.826,1.826,0,0,0,256,1.826v7.3a1.826,1.826,0,0,0,1.826,1.826h1.826V13.39a.609.609,0,0,0,.407.574.628.628,0,0,0,.2.034.608.608,0,0,0,.475-.228l2.251-2.815H270a1.826,1.826,0,0,0,1.826-1.826v-7.3A1.826,1.826,0,0,0,270,0Zm.609,9.129a.609.609,0,0,1-.609.609h-7.3a.608.608,0,0,0-.475.228l-1.351,1.688V10.347a.609.609,0,0,0-.609-.609h-2.434a.609.609,0,0,1-.609-.609v-7.3a.609.609,0,0,1,.609-.609H270a.609.609,0,0,1,.609.609Zm0,0"
                          transform="translate(-236.524)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_16"
                          data-name="Caminho 16"
                          d="M304,32h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -29.566)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_17"
                          data-name="Caminho 17"
                          d="M304,64h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -59.131)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_18"
                          data-name="Caminho 18"
                          d="M304,96h8.521v1.217H304Zm0,0"
                          transform="translate(-280.872 -88.697)"
                          fill="#d98840"
                        />
                      </svg>

                      <strong>
                        <span>performance</span>
                        Disponíveis
                      </strong>
                      <div class="fd-dashboard-card-list-item-header-action">
                        <a
                          :href="'/plataforma/' + $route.params.id_plataforma + '/admin/usuarios?Alunos'"
                          target="_blank"
                        >Gerenciar performance</a>
                      </div>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <ul class="fd-dashboard-card-list-item-body-card-list">
                        <li class="fd-dashboard-card-list-item-body-card-list-item media">
                          <div class="fd-dashboard-card-list-item-body-card-list-item-header">
                            <span id="dashNotaMedia">{{ prova_nota_media }}</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="48.848"
                              height="43.5"
                              viewBox="0 0 48.848 43.5"
                            >
                              <g
                                id="hand"
                                transform="translate(0 -28.029)"
                              >
                                <g
                                  id="Grupo_4"
                                  data-name="Grupo 4"
                                  transform="translate(5.724 50.539)"
                                >
                                  <g
                                    id="Grupo_3"
                                    data-name="Grupo 3"
                                  >
                                    <path
                                      id="Caminho_2"
                                      data-name="Caminho 2"
                                      d="M60.954,263.972a.954.954,0,1,0,.954.954A.954.954,0,0,0,60.954,263.972Z"
                                      transform="translate(-60 -263.972)"
                                      fill="#d98840"
                                    />
                                  </g>
                                </g>
                                <g
                                  id="Grupo_6"
                                  data-name="Grupo 6"
                                  transform="translate(0 28.029)"
                                >
                                  <g
                                    id="Grupo_5"
                                    data-name="Grupo 5"
                                  >
                                    <path
                                      id="Caminho_3"
                                      data-name="Caminho 3"
                                      d="M48.848,53.878a4.286,4.286,0,0,0-1.6-3.338,4.3,4.3,0,0,0,1.54-4.054,4.426,4.426,0,0,0-4.414-3.579H35.288l.283-.849a12.145,12.145,0,0,0-3.444-13.064,4.035,4.035,0,0,0-6.421,1.694.954.954,0,0,0-.014.615c.793,2.521.8,4.216.039,5.85-.793,1.7-2.5,3.475-5.706,5.952a14.176,14.176,0,0,1-2.093,1.309,8.79,8.79,0,0,0-3,2.308H11.449v-.954a.954.954,0,0,0-.954-.954H.954A.954.954,0,0,0,0,45.769V70.574a.954.954,0,0,0,.954.954h9.541a.954.954,0,0,0,.954-.954V67.712H16.8a15.11,15.11,0,0,0,10.068,3.816H38.831A4.291,4.291,0,0,0,42.4,64.85h.248a4.29,4.29,0,0,0,3.38-6.937A4.293,4.293,0,0,0,48.848,53.878ZM9.541,69.62H1.908v-22.9H9.541ZM44.555,56.264H35.4a.954.954,0,1,0,0,1.908h7.251a2.385,2.385,0,1,1,0,4.77H35.4a.954.954,0,1,0,0,1.908h3.435a2.385,2.385,0,1,1,0,4.77H26.868a13.208,13.208,0,0,1-9.048-3.559.954.954,0,0,0-.651-.257H11.449V48.631h3.946a.954.954,0,0,0,.768-.388,6.763,6.763,0,0,1,2.675-2.149,15.982,15.982,0,0,0,2.353-1.478c6.532-5.046,8.027-8.137,6.427-13.54a2.123,2.123,0,0,1,3.331-.577,10.188,10.188,0,0,1,2.812,10.956l-.484,1.452h-1.22a.954.954,0,1,0,0,1.908h12.32a2.505,2.505,0,0,1,2.53,1.978,2.386,2.386,0,0,1-2.352,2.793H35.4a.954.954,0,1,0,0,1.908h9.159a2.385,2.385,0,1,1,0,4.77Z"
                                      transform="translate(0 -28.029)"
                                      fill="#d98840"
                                    />
                                  </g>
                                </g>
                                <g
                                  id="Grupo_8"
                                  data-name="Grupo 8"
                                  transform="translate(5.724 54.355)"
                                >
                                  <g
                                    id="Grupo_7"
                                    data-name="Grupo 7"
                                  >
                                    <path
                                      id="Caminho_4"
                                      data-name="Caminho 4"
                                      d="M60.954,303.972a.954.954,0,0,0-.954.954v9.541a.954.954,0,1,0,1.908,0v-9.541A.954.954,0,0,0,60.954,303.972Z"
                                      transform="translate(-60 -303.972)"
                                      fill="#d98840"
                                    />
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div class="fd-dashboard-card-list-item-body-card-list-item-footer">
                            <strong>Média de Aproveitamento</strong>
                          </div>
                        </li>
                        <li class="fd-dashboard-card-list-item-body-card-list-item pior-resultado">
                          <div class="fd-dashboard-card-list-item-body-card-list-item-header">
                            <span id="dashNotaMinima">{{ prova_nota_minima }}</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="48.072"
                              height="42.72"
                              viewBox="0 0 48.072 42.72"
                            >
                              <g
                                id="dislike"
                                transform="translate(0 0)"
                              >
                                <path
                                  id="Caminho_5"
                                  data-name="Caminho 5"
                                  d="M48.072,17.389A4.235,4.235,0,0,0,44.6,13.23a4.223,4.223,0,0,0-1.81-6.313A4.227,4.227,0,0,0,39.533,0h-16.6a12.349,12.349,0,0,0-7.287,2.362L14.186,3.421A3.431,3.431,0,0,0,10.759,0H3.427A3.431,3.431,0,0,0,0,3.427v7.558a.939.939,0,1,0,1.878,0V3.427A1.551,1.551,0,0,1,3.427,1.878h7.332a1.551,1.551,0,0,1,1.549,1.549V26.055A1.551,1.551,0,0,1,10.759,27.6H3.427a1.551,1.551,0,0,1-1.549-1.549V18.5A.939.939,0,0,0,0,18.5v7.558a3.431,3.431,0,0,0,3.427,3.427h7.332a3.433,3.433,0,0,0,3.358-2.742,10.077,10.077,0,0,1,7.18,9.643v4.459a1.88,1.88,0,0,0,1.878,1.878,7.093,7.093,0,0,0,7.085-7.085V28.2H41.14a4.226,4.226,0,0,0,3.464-6.65,4.235,4.235,0,0,0,3.467-4.159ZM43.843,19.74H29.252a.939.939,0,1,0,0,1.878H41.14a2.351,2.351,0,1,1,0,4.7H29.322a.939.939,0,0,0-.939.939v8.376a5.213,5.213,0,0,1-5.207,5.207V36.383a11.956,11.956,0,0,0-8.989-11.574V5.739L16.75,3.883a10.481,10.481,0,0,1,6.186-2h16.6a2.351,2.351,0,1,1,0,4.7H29.392a.939.939,0,1,0,0,1.878H41.14a2.351,2.351,0,1,1,0,4.7H29.251a.939.939,0,1,0,0,1.878H43.843a2.351,2.351,0,0,1,0,4.7Zm0,0"
                                  transform="translate(0)"
                                  fill="#dd2525"
                                />
                                <path
                                  id="Caminho_6"
                                  data-name="Caminho 6"
                                  d="M49.556,57a3,3,0,1,0-3,3A3.008,3.008,0,0,0,49.556,57Zm-4.131,0a1.127,1.127,0,1,1,1.127,1.127A1.128,1.128,0,0,1,45.425,57Zm0,0"
                                  transform="translate(-39.458 -48.93)"
                                  fill="#dd2525"
                                />
                                <path
                                  id="Caminho_7"
                                  data-name="Caminho 7"
                                  d="M.939,148.878a.939.939,0,1,0-.664-1.6.939.939,0,0,0,.664,1.6Zm0,0"
                                  transform="translate(0 -133.198)"
                                  fill="#dd2525"
                                />
                              </g>
                            </svg>
                          </div>
                          <div class="fd-dashboard-card-list-item-body-card-list-item-footer">
                            <strong>Pior resultado</strong>
                          </div>
                        </li>
                        <li
                          class="fd-dashboard-card-list-item-body-card-list-item melhor-resultado"
                        >
                          <div class="fd-dashboard-card-list-item-body-card-list-item-header">
                            <span id="dashNotaMaxima">{{ prova_nota_maxima }}</span>
                            <svg
                              id="podium"
                              xmlns="http://www.w3.org/2000/svg"
                              width="53"
                              height="53"
                              viewBox="0 0 53 53"
                            >
                              <path
                                id="Caminho_8"
                                data-name="Caminho 8"
                                d="M132.211,1.035v2.07h-5.176A1.035,1.035,0,0,0,126,4.141V7.246a4.145,4.145,0,0,0,4.141,4.141h3.371a7.217,7.217,0,0,0,4.911,3.032v4.836h-2.07a1.035,1.035,0,0,0-.926.572l-3.105,6.211a1.035,1.035,0,0,0,.926,1.5h12.422a1.035,1.035,0,0,0,.926-1.5l-3.105-6.211a1.036,1.036,0,0,0-.926-.572h-2.07V14.416a7.281,7.281,0,0,0,4.91-3.03h3.371a4.145,4.145,0,0,0,4.141-4.141V4.141a1.035,1.035,0,0,0-1.035-1.035H146.7V1.035A1.035,1.035,0,0,0,145.668,0H133.246a1.035,1.035,0,0,0-1.035,1.035Zm11.782,24.43h-9.072l2.07-4.141h4.931ZM128.07,7.246V5.176h4.141v2.07a7.261,7.261,0,0,0,.3,2.07h-2.372A2.073,2.073,0,0,1,128.07,7.246Zm22.773-2.07v2.07a2.073,2.073,0,0,1-2.07,2.07H146.4a7.261,7.261,0,0,0,.3-2.07V5.176ZM134.281,2.07h10.352V7.246a5.176,5.176,0,1,1-10.352,0Z"
                                transform="translate(-112.957)"
                                fill="#0e9f13"
                              />
                              <path
                                id="Caminho_9"
                                data-name="Caminho 9"
                                d="M223.246,371.07a1.035,1.035,0,0,0,0-2.07h-6.211a1.035,1.035,0,0,0,0,2.07h2.07v4.141h-2.07a1.035,1.035,0,0,0,0,2.07h6.211a1.035,1.035,0,0,0,0-2.07h-2.07V371.07Z"
                                transform="translate(-193.641 -330.803)"
                                fill="#0e9f13"
                              />
                              <ellipse
                                id="Elipse_6"
                                data-name="Elipse 6"
                                cx="1.5"
                                cy="1"
                                rx="1.5"
                                ry="1"
                                transform="translate(43 51)"
                                fill="#0e9f13"
                              />
                              <path
                                id="Caminho_10"
                                data-name="Caminho 10"
                                d="M49.895,315.627H36.852v-6.521A3.109,3.109,0,0,0,33.746,306H19.254a3.109,3.109,0,0,0-3.105,3.105v3.416H3.105A3.109,3.109,0,0,0,0,315.627v10.662a1.035,1.035,0,0,0,1.035,1.035H39.75a1.035,1.035,0,1,0,0-2.07h-2.9V317.7H49.895a1.036,1.036,0,0,1,1.035,1.035v6.521H49.066a1.035,1.035,0,0,0,0,2.07h2.9A1.035,1.035,0,0,0,53,326.289v-7.557A3.109,3.109,0,0,0,49.895,315.627Zm-47.824,0a1.036,1.036,0,0,1,1.035-1.035H16.148v10.662H2.07Zm16.148-6.521a1.036,1.036,0,0,1,1.035-1.035H33.746a1.036,1.036,0,0,1,1.035,1.035v16.148H18.219Z"
                                transform="translate(0 -274.324)"
                                fill="#0e9f13"
                              />
                            </svg>
                          </div>
                          <div class="fd-dashboard-card-list-item-body-card-list-item-footer">
                            <strong>Melhor resultado</strong>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="fd-dashboard-card-list">
                  <div class="fd-dashboard-card-list-item">
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        id="develop"
                        xmlns="http://www.w3.org/2000/svg"
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                      >
                        <g
                          id="Grupo_24"
                          data-name="Grupo 24"
                        >
                          <g
                            id="Grupo_23"
                            data-name="Grupo 23"
                          >
                            <path
                              id="Caminho_33"
                              data-name="Caminho 33"
                              d="M37.656,27.813h-2.5V7.281h.257a.781.781,0,0,0,.662-1.2l-2.6-4.154a.781.781,0,0,0-1.324,0l-2.6,4.154a.781.781,0,0,0,.662,1.2h.257V22.422a.781.781,0,0,0,1.563,0V6.5a.782.782,0,0,0-.454-.71l1.235-1.972L34.048,5.79a.782.782,0,0,0-.454.71V27.813H27.969a2.346,2.346,0,0,0-2.344,2.344v.291a2.333,2.333,0,0,0-.781-.134H21.333V21.707A3.911,3.911,0,0,0,17.427,17.8H16.5v-.952a2.622,2.622,0,0,0,1.075.23h4.053a2.314,2.314,0,1,0,0-4.628H19.622v-.879a5.164,5.164,0,0,0-3.77-4.965,3.614,3.614,0,0,0,.792-2.26V3.632a3.632,3.632,0,1,0-7.264,0v.713a3.613,3.613,0,0,0,.766,2.227,5.165,5.165,0,0,0-3.891,5v4.048A3.906,3.906,0,0,0,9.38,19.442v4.426a.781.781,0,1,0,1.562,0v-4.5h6.484a2.346,2.346,0,0,1,2.344,2.344v8.606H17.9V22.65a.781.781,0,0,0-.781-.781H13.594a.781.781,0,0,0-.781.781V34.063h-1.87V30.234a.781.781,0,0,0-1.562,0v3.828H2.344A2.346,2.346,0,0,0,0,36.406v2.813A.781.781,0,0,0,.781,40H39.219A.781.781,0,0,0,40,39.219V30.156A2.346,2.346,0,0,0,37.656,27.813ZM10.942,3.632a2.07,2.07,0,1,1,4.14,0v.713a2.07,2.07,0,0,1-4.14,0Zm4.779,7.951a.781.781,0,0,0-.781.781V17.8h-4V12.364a.781.781,0,1,0-1.562,0v5.46a2.341,2.341,0,0,1-1.563-2.2V11.571a3.6,3.6,0,0,1,3.594-3.594h3.055a3.6,3.6,0,0,1,3.594,3.594v1.66a.781.781,0,0,0,.781.781h2.79a.752.752,0,1,1,0,1.5H17.578A1.076,1.076,0,0,1,16.5,14.441V12.364A.781.781,0,0,0,15.722,11.583ZM12.813,38.438H1.563V36.406a.782.782,0,0,1,.781-.781h9.688a.782.782,0,0,1,.781.781Zm1.563-15.006h1.958v6.881H15.156a2.333,2.333,0,0,0-.781.134Zm11.25,15.006H14.375V32.656a.782.782,0,0,1,.781-.781h9.688a.782.782,0,0,1,.781.781Zm12.813,0H27.188V30.156a.782.782,0,0,1,.781-.781h9.688a.782.782,0,0,1,.781.781Z"
                              fill="#d98840"
                            />
                          </g>
                        </g>
                        <g
                          id="Grupo_26"
                          data-name="Grupo 26"
                          transform="translate(9.38 26.124)"
                        >
                          <g
                            id="Grupo_25"
                            data-name="Grupo 25"
                          >
                            <path
                              id="Caminho_34"
                              data-name="Caminho 34"
                              d="M121.394,334.619a.781.781,0,1,0,.229.552A.788.788,0,0,0,121.394,334.619Z"
                              transform="translate(-120.06 -334.39)"
                              fill="#d98840"
                            />
                          </g>
                        </g>
                        <g
                          id="Grupo_28"
                          data-name="Grupo 28"
                          transform="translate(30.469 24.609)"
                        >
                          <g
                            id="Grupo_27"
                            data-name="Grupo 27"
                          >
                            <path
                              id="Caminho_35"
                              data-name="Caminho 35"
                              d="M391.334,315.229a.781.781,0,1,0,.229.552A.787.787,0,0,0,391.334,315.229Z"
                              transform="translate(-390 -315)"
                              fill="#d98840"
                            />
                          </g>
                        </g>
                      </svg>
                      <strong>
                        <span>Cursos</span>
                        Inacabados
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <div class="fd-dashboard-card-list-item-body">
                        <div
                          id="dashCursosInacabados"
                          class="fd-dashboard-card-list-item-body-info"
                        >
                          <span>{{ cursos_inacabados }}</span>
                          <strong>{{ nome_plataforma }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/usuarios?Alunos'"
                        target="_blank"
                      >Gerenciar performance</a>
                    </div>
                  </div>

                  <div class="fd-dashboard-card-list-item">
                    <div class="fd-dashboard-card-list-item-header">
                      <svg
                        id="podium"
                        xmlns="http://www.w3.org/2000/svg"
                        width="31"
                        height="31"
                        viewBox="0 0 31 31"
                      >
                        <path
                          id="Caminho_8"
                          data-name="Caminho 8"
                          d="M129.633.605V1.816h-3.027a.606.606,0,0,0-.605.605V4.238a2.425,2.425,0,0,0,2.422,2.422h1.971a4.221,4.221,0,0,0,2.872,1.773v2.828h-1.211a.605.605,0,0,0-.542.335L129.7,15.229a.606.606,0,0,0,.542.876H137.5a.605.605,0,0,0,.542-.876L136.229,11.6a.606.606,0,0,0-.542-.335h-1.211V8.432a4.259,4.259,0,0,0,2.872-1.772h1.972a2.425,2.425,0,0,0,2.422-2.422V2.422a.606.606,0,0,0-.605-.605h-3.027V.605A.606.606,0,0,0,137.5,0h-7.266a.606.606,0,0,0-.605.605Zm6.891,14.289h-5.306l1.211-2.422h2.884ZM127.211,4.238V3.027h2.422V4.238a4.247,4.247,0,0,0,.177,1.211h-1.388A1.212,1.212,0,0,1,127.211,4.238Zm13.32-1.211V4.238a1.212,1.212,0,0,1-1.211,1.211h-1.388a4.247,4.247,0,0,0,.177-1.211V3.027Zm-9.687-1.816H136.9V4.238a3.027,3.027,0,1,1-6.055,0Z"
                          transform="translate(-118.371)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_9"
                          data-name="Caminho 9"
                          d="M220.238,370.211a.605.605,0,0,0,0-1.211h-3.633a.605.605,0,0,0,0,1.211h1.211v2.422h-1.211a.605.605,0,0,0,0,1.211h3.633a.605.605,0,0,0,0-1.211h-1.211v-2.422Z"
                          transform="translate(-202.922 -346.658)"
                          fill="#d98840"
                        />
                        <ellipse
                          id="Elipse_6"
                          data-name="Elipse 6"
                          cx="1"
                          cy="0.5"
                          rx="1"
                          ry="0.5"
                          transform="translate(25 30)"
                          fill="#d98840"
                        />
                        <path
                          id="Caminho_10"
                          data-name="Caminho 10"
                          d="M29.184,311.631H21.555v-3.814A1.818,1.818,0,0,0,19.738,306H11.262a1.818,1.818,0,0,0-1.816,1.816v2H1.816A1.818,1.818,0,0,0,0,311.631v6.236a.606.606,0,0,0,.605.605H23.25a.605.605,0,1,0,0-1.211h-1.7v-4.42h7.629a.606.606,0,0,1,.605.605v3.814H28.7a.605.605,0,0,0,0,1.211h1.7a.606.606,0,0,0,.605-.605v-4.42A1.818,1.818,0,0,0,29.184,311.631Zm-27.973,0a.606.606,0,0,1,.605-.605H9.445v6.236H1.211Zm9.445-3.814a.606.606,0,0,1,.605-.605h8.477a.606.606,0,0,1,.605.605v9.445H10.656Z"
                          transform="translate(0 -287.473)"
                          fill="#d98840"
                        />
                      </svg>

                      <strong>
                        <span>TOP 5</span>
                        Capacitações
                      </strong>
                    </div>
                    <div class="fd-dashboard-card-list-item-body">
                      <ul
                        id="dashTopCapacitacoes"
                        class="fd-dashboard-card-list-item-body-card-list top-list"
                      >
                        <li
                          v-for="matriz in matrizes_capacitacao"
                          :key="matriz.split(',')[0]"
                          class="fd-dashboard-card-list-item-body-card-list-item rank"
                        >
                          <div class="fd-dashboard-card-list-item-body-card-list-item-header">
                            <div
                              class="fd-dashboard-card-list-item-body-card-list-item-header-pos"
                            >
                              1ª
                            </div>
                            <strong>{{ matriz.split(",")[0] }}</strong>
                            <span>{{ matriz.split(",")[1] }}</span>
                          </div>
                          <div class="fd-dashboard-card-list-item-body-card-list-item-footer">
                            <strong>Cursos</strong>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="fd-dashboard-card-list-item-footer">
                      <a
                        :href="'/plataforma/' + $route.params.id_plataforma + '/admin/matriz-capacitacao'"
                        target="_blank"
                      >Acessar matriz de capacitação</a>
                    </div>
                  </div>
                </div>
              </section>
              <!-- fd-app-capacitacoes -->
              <!-- fd-app-meus-cursos -->
              <div class="mt-5 mb-5">
                <a
                  id="btn_voltar_modo_admin"
                  class="btn btn-red-hollow"
                  :href="'/plataforma/' + $route.params.id_plataforma + '/admin'"
                  @click.prevent="$router.push('/plataforma/' + $route.params.id_plataforma + '/admin')"
                >
                  <b-icon-arrow-return-left />
                  Voltar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { settings } from "@/config";
import methods from "@/methods";
//import ImageSiteFormEffect01 from "@/assets/images/form-effect-01.png";

export default {
  name: "HomeInternoAdminDashboard",
  mixins: [methods],
  data: function () {
    return {
      //ImageSiteFormEffect01,
      nome_plataforma: "",
      banner_plataforma: "",
      logo_plataforma: "",
      aluno_nota_minima: null,
      cursos_inacabados: 0,
      id_aluno_nota_maxima: null,
      matrizes_capacitacao: [],
      plataformas_filhas_string: [],
      prova_nota_maxima: null,
      prova_nota_media: null,
      prova_nota_minima: null,
      total_cursos_em_execucao: 3,
      total_cursos_mae: 9,
      total_cursos_publicados_mae: 5,
      total_nota_alunos: null,
      total_nota_provas: null,
      total_professores: 0,
      total_provas: 0,
      total_usuarios_mae: 6,
      total_usuarios_treinados: 1,
      plataformas_filhas: [],
    };
  },
  mounted: function () {
    // Captura ID da plataforma pela URL
    if (this.$route.params.id_plataforma) {
      this.getFastDependecias(this.$route.params.id_plataforma, 'administrador')
        .then(() => {
          this.getPlataformaDashboard();
          if (this.$store.state.fastPermissoes.id_admin_pai == "0")
            this.getPlataformasFilhas();
          this.$store.state.fastCarregando = false;         
        })
        .catch((e) => {
          this.exibeToasty(e, "error");
          this.$store.state.fastCarregando = false;
        });
    }
  },
  methods: {
    async getPlataformaDashboard() {
      try {
        let resp = await fetch(
          settings.endApiFastEad +
            "api/fast_plataforma/lista_dashboard?id_plataforma=" +
            this.$route.params.id_plataforma,
          this.fastAjaxOptions("GET")
        );
        let json = await resp.json();
        let objPlataforma = Array.from(json);
        if (objPlataforma.length > 0) {
          //console.log(objPlataforma);
          this.aluno_nota_minima = objPlataforma[0].aluno_nota_minima;
          this.cursos_inacabados = objPlataforma[0].cursos_inacabados;
          this.id_aluno_nota_maxima = objPlataforma[0].id_aluno_nota_maxima;
          if (objPlataforma[0].matrizes_capacitacao)
            this.matrizes_capacitacao = objPlataforma[0].matrizes_capacitacao.split(
              ";"
            );
          if (objPlataforma[0].plataformas_filhas_string)
            this.plataformas_filhas_string = objPlataforma[0].plataformas_filhas_string.split(
              ";"
            );

          this.prova_nota_maxima = objPlataforma[0].prova_nota_maxima;
          this.prova_nota_media = objPlataforma[0].prova_nota_media;
          this.prova_nota_minima = objPlataforma[0].prova_nota_minima;
          this.total_cursos_em_execucao =
            objPlataforma[0].total_cursos_em_execucao;
          this.total_cursos_mae = objPlataforma[0].total_cursos_mae;
          this.total_cursos_publicados_mae =
            objPlataforma[0].total_cursos_publicados_mae;
          this.total_nota_alunos = objPlataforma[0].total_nota_alunos;
          this.total_nota_provas = objPlataforma[0].total_nota_provas;
          this.total_professores = objPlataforma[0].total_professores;
          this.total_provas = objPlataforma[0].total_provas;
          this.total_usuarios_mae = objPlataforma[0].total_usuarios_mae;
          this.total_usuarios_treinados =
            objPlataforma[0].total_usuarios_treinados;
        }
      } catch (e) {
        console.log("Erro", e);
      }
    },
    async getPlataformasFilhas() {
      try {
        let resp = await fetch(
          settings.endApiFastEad +
            "api/fast_plataforma/lista_filhas?id_plataforma=" +
            this.$route.params.id_plataforma,
          this.fastAjaxOptions("GET")
        );
        let json = await resp.json();
        let objPlataforma = Array.from(json);
        if (objPlataforma.length > 0) {
          this.plataformas_filhas = objPlataforma.filter(
            (e) => e.id_plataforma != this.$route.params.id_plataforma
          );
        }
      } catch (e) {
        console.log("Erro", e);
      }
    },
    async excluirPlataforma() {
      let model = {
        fast_plataforma_usuario: {
          id_plataforma: this.$store.state.fastPermissoes.id_plataforma,
        },
      };

      fetch(
        `${settings.endApiFastEad}api/fast_plataforma/exclui`,
        this.fastAjaxOptions("POST", JSON.stringify(model))
      )
        .then((resp) => resp.json())
        .then((obj) => {
          console.log(obj);
          sessionStorage.setItem(settings.fastSessaoPermissoes, null);
          sessionStorage.setItem(settings.fastSessaoPlataforma, null);
          window.location.href = "/minhas-plataformas";
        })
        .catch((e) => console.log(e));
    },
  },
};
</script>

<style></style>